import { youtube_parser } from "./youtube-url-parser";

// YouTube hosts a thumbnail for every video; no upload needed.
export const youtubeThumb = (videoUrl: string, quality: "maxresdefault" | "hqdefault" = "maxresdefault") => `https://i.ytimg.com/vi/${youtube_parser(videoUrl)}/${quality}.jpg`;

export const isYoutubeThumb = (url: string) => url.startsWith("https://i.ytimg.com/");
